import { GetComponentProjectListResponse } from "../../../services/component-projects";
import { GetIFDefinitionsResponse } from "../../../services/if-definitions";
import {
  ComponentProjectList,
  ComponentRequirementList,
} from "../../project-plan/ProjectPlanPageState";

export type LinkComponentProjectDialogState = {
  ifDefinitionResult: GetIFDefinitionsResponse;
  componentProjectResult: GetComponentProjectListResponse;
  isShow: boolean;
  saved: {
    componentRequirementList?: ComponentRequirementList[];
    cmpntPrjList?: ComponentProjectList[];
  };
  edited: {
    componentRequirementList?: ComponentRequirementList[];
    cmpntPrjList?: ComponentProjectList[];
  };
  codes: {
    chnTypeType?: Option[];
    edhNotificationType?: Option[];
  };
  displayColumn: Option[];
  pjtId: string;
  updateDateTime: string;
  status: {
    invalidList: string[];
    invalidRecordList: string[];
    isSaved: boolean;
  };
  spreadSheet: {
    tmplateRow: SpreadsheetRecordData;
  };
  refSpreadSheet: {
    tmplateRow: RefSpreadsheetRecordData;
  };
};

export type Option = {
  label: string;
  value: string;
};

export type CellItem = {
  rowIdx: number;
  col: string;
};

export type RefSpreadsheetState = {
  results: RefSpreadsheetRecordData[];
  codes?: {};
};

export type RefSpreadsheetRecordData = {
  dipByRgn: string;
  cpntId: string;
  cpntReqDesc: string;
  inOutTypeCd: string;
  edhPrtcls: string[];
  ediPrtnrs: string[];
  edhNotifications: string[];
};

export type SpreadsheetState = {
  results: SpreadsheetRecordData[];
  codes?: {};
};

export type SpreadsheetRecordData = {
  select: boolean;
  dipByRgn: string;
  cpntId: string;
  cpntPjtTypeName: string;
  inOutTypeName: string;
  prtclTypeName: string;
  cpntPrjName: string;
  message?: SpreadsheetMessage[] | null;
  messageVal?: string;
  cpntPjtId: string;
  updateFlag?: boolean;
};

export type SpreadsheetMessage = {
  messageId: string;
  message: string;
  column: string;
};

export type PageNewState =
  | LinkComponentProjectDialogState
  | ((
      prevState: LinkComponentProjectDialogState,
    ) => LinkComponentProjectDialogState);
